import React, { useState } from 'react'
import ToggleSwitch from '../../ReusableComponents/ToggleSwitch/ToggleSwitch'
import { drawState, clearDrawing } from './detectors/gestureDetector'
import styles from './Vision.module.css'

const COLORS = ['#f4813f', '#4a9fe0', '#4cc9a0', '#e0574b', '#9b6ef3', '#ffffff']

// Sidebar controls for the gesture play mode: finger-drawing toggle, pen colour
// and thickness, and a clear button. Draw with your index fingertip.
const GestureOptions = () => {
    const [enabled, setEnabled] = useState(drawState.enabled)
    const [color, setColor] = useState(drawState.color)
    const [thickness, setThickness] = useState(drawState.thickness)
    const [, force] = useState(0)

    const onToggle = (n) => {
        drawState.enabled = n
        setEnabled(n)
    }
    const onColor = (c) => {
        drawState.color = c
        setColor(c)
    }
    const onThickness = (e) => {
        const v = Number(e.target.value)
        drawState.thickness = v
        setThickness(v)
    }

    return (
        <div className={styles.trackOptions}>
            <div className={styles.trackOptToggleRow}>
                <span className={styles.trackOptLabel}>Draw with finger</span>
                <ToggleSwitch
                    size="md"
                    tone="orange"
                    checked={enabled}
                    onChange={onToggle}
                    ariaLabel="Toggle finger drawing"
                />
            </div>
            {enabled && (
                <>
                    <div className={styles.trackOptRow}>
                        <span className={styles.trackOptLabel}>Colour</span>
                        <div className={styles.drawColors}>
                            {COLORS.map((c) => (
                                <button
                                    key={c}
                                    className={`${styles.drawSwatch} ${
                                        c === color ? styles.drawSwatchOn : ''
                                    }`}
                                    style={{ background: c }}
                                    onClick={() => onColor(c)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className={styles.trackOptRow}>
                        <span className={styles.trackOptLabel}>
                            Thickness: {thickness}
                        </span>
                        <input
                            type="range"
                            min="2"
                            max="20"
                            value={thickness}
                            onChange={onThickness}
                        />
                    </div>
                    <button
                        className={styles.trackLineBtn}
                        onClick={() => {
                            clearDrawing()
                            force((n) => n + 1)
                        }}
                    >
                        Clear Drawing
                    </button>
                    <span className={styles.trackLineHint}>
                        Point your index finger at the camera to draw.
                    </span>
                </>
            )}
        </div>
    )
}

export default GestureOptions
